import { Button } from '@/components/ui/button';
import { List, Workflow } from 'lucide-react';

export type WorkflowView = 'list' | 'visual';

interface WorkflowViewToggleProps {
  currentView: WorkflowView;
  onViewChange: (view: WorkflowView) => void;
}

export function WorkflowViewToggle({ currentView, onViewChange }: WorkflowViewToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-border bg-background p-1">
      <Button
        variant={currentView === 'list' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('list')}
        className="gap-2"
      >
        <List className="h-4 w-4" />
        List View
      </Button>
      <Button
        variant={currentView === 'visual' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('visual')}
        className="gap-2"
      >
        <Workflow className="h-4 w-4" />
        Visual Flow
      </Button>
    </div>
  );
}
